/**
 * DIBAI 18K — Historia (slider de fotos por hito)
 * assets/historia-dibai.js  v1.0.0
 */
(function () {
  'use strict';

  function initSlider(media) {
    const track  = media.querySelector('[data-hist-slides]');
    const dotsEl = media.querySelector('[data-hist-dots]');
    const prev   = media.querySelector('[data-hist-prev]');
    const next   = media.querySelector('[data-hist-next]');
    const slides = Array.from(track?.children || []);
    if (!track || slides.length < 2) return;

    let current  = 0;
    let startX   = 0;
    let isDrag   = false;

    // Crear dots
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'hist-slide-dot' + (i === 0 ? ' hist-slide-dot--active' : '');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Foto ${i + 1}`);
      dot.addEventListener('click', () => go(i));
      dotsEl?.appendChild(dot);
    });

    // Contador
    const counter = document.createElement('div');
    counter.className = 'hist-slide-counter';
    counter.textContent = `1 / ${slides.length}`;
    media.appendChild(counter);

    function go(idx) {
      current = ((idx % slides.length) + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;

      // Dots
      dotsEl?.querySelectorAll('.hist-slide-dot').forEach((d, i) => {
        d.classList.toggle('hist-slide-dot--active', i === current);
      });

      // Contador
      counter.textContent = `${current + 1} / ${slides.length}`;
    }

    prev?.addEventListener('click', () => go(current - 1));
    next?.addEventListener('click', () => go(current + 1));

    // Touch/mouse swipe
    function onStart(e) {
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      isDrag = true;
    }
    function onEnd(e) {
      if (!isDrag) return;
      isDrag = false;
      const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 40) go(diff > 0 ? current + 1 : current - 1);
    }

    media.addEventListener('mousedown', onStart);
    media.addEventListener('mouseup', onEnd);
    media.addEventListener('touchstart', onStart, { passive: true });
    media.addEventListener('touchend', onEnd, { passive: true });

    // Auto-play suave
    let timer = setInterval(() => go(current + 1), 3500);
    media.addEventListener('mouseenter', () => clearInterval(timer));
    media.addEventListener('mouseleave', () => {
      timer = setInterval(() => go(current + 1), 3500);
    });
  }

  function init(root) {
    root.querySelectorAll('[data-hist-slider]').forEach(initSlider);
  }

  function initAll() {
    document.querySelectorAll('.historia-dibai-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.historia-dibai-wrapper') || e.target.closest('.historia-dibai-wrapper');
    if (root) init(root);
  });
})();

/* ─────────────────────────────────────────
   LIGHTBOX — Historia DIBAI
   ───────────────────────────────────────── */
(function () {
  'use strict';

  function initLightbox(wrapper) {
    const lb      = wrapper.querySelector('[data-hist-lightbox]');
    if (!lb) return;
    const imgWrap = lb.querySelector('[data-hist-lb-img-wrap]');
    const counter = lb.querySelector('[data-hist-lb-counter]');
    const prevBtn = lb.querySelector('[data-hist-lb-prev]');
    const nextBtn = lb.querySelector('[data-hist-lb-next]');

    let images = [];  // { src, alt }
    let current = 0;
    let lastFocus = null;
    let startX = 0;

    function buildImages(hito) {
      const slides = hito.querySelectorAll('[data-hist-lb-open]');
      return Array.from(slides).map(el => {
        const img = el.querySelector('img') || el;
        return {
          src: img.dataset.srcFull || img.src,
          alt: img.alt || ''
        };
      });
    }

    function open(hito, index) {
      images  = buildImages(hito);
      current = index;
      lastFocus = document.activeElement;
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      render();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      imgWrap.innerHTML = '<div class="hist-lb__spinner"></div>';
      lastFocus?.focus();
    }

    function go(dir) {
      current = ((current + dir) + images.length) % images.length;
      render();
    }

    function render() {
      if (!images.length) return;
      if (counter) counter.textContent = `${current + 1} / ${images.length}`;
      imgWrap.innerHTML = '<div class="hist-lb__spinner"></div>';
      const img = new Image();
      img.className = 'hist-lb__img';
      img.alt = images[current].alt;
      img.onload = () => { imgWrap.innerHTML = ''; imgWrap.appendChild(img); };
      img.onerror = () => { imgWrap.innerHTML = '<p style="color:#fff;font-size:14px;">No se pudo cargar la imagen.</p>'; };
      img.src = images[current].src;
    }

    function onKey(e) {
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft')  go(-1);
    }

    // Swipe
    lb.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend',   e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) go(diff > 0 ? 1 : -1);
    }, { passive: true });

    prevBtn?.addEventListener('click', () => go(-1));
    nextBtn?.addEventListener('click', () => go(1));
    lb.querySelectorAll('[data-hist-lb-close]').forEach(el => el.addEventListener('click', close));

    // Abrir desde slides o imagen simple
    wrapper.addEventListener('click', e => {
      const trigger = e.target.closest('[data-hist-lb-open]');
      if (!trigger) return;
      const hito = trigger.closest('[data-hist-item]');
      if (!hito) return;
      const idx = parseInt(trigger.dataset.histLbOpen || '0', 10);
      open(hito, idx);
    });
  }

  function init() {
    document.querySelectorAll('.historia-dibai-wrapper').forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', e => {
    const w = e.target.querySelector('.historia-dibai-wrapper');
    if (w) initLightbox(w);
  });
})();
